export default __webpack_public_path__ + "static/media/eval-reports.a66d1fd4.png";